import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '11. Open the Sleigh Shop Door';
  const flag = 'The Tooth Fairy';
  const hints = [
  (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] Chrome Dev Tools</Text><a rel="noopener noreferrer" href='https://developers.google.com/web/tools/chrome-devtools'>Chrome Dev Tools</a></Flex>),
  (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] Firefox Dev Tools</Text><a rel="noopener noreferrer" href='https://developer.mozilla.org/en-US/docs/Tools'>Firefox Dev Tools</a></Flex>),
  (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] Safari Dev Tools</Text><a rel="noopener noreferrer" href='https://developer.apple.com/safari/tools/'>Safari Dev Tools</a></Flex>),
  (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] Edge Dev Tools</Text><a rel="noopener noreferrer" href='https://docs.microsoft.com/en-us/microsoft-edge/devtools-guide/console'>Edge Dev Tools</a></Flex>),
  (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Kent Tinseltooth] Curl Dev Tools</Text><a rel="noopener noreferrer" href='https://curl.haxx.se/docs/manpage.html'>Curl Dev Tools</a></Flex>),
  `[Kent Tinseltooth Chat] By the way, have you tried to get into the crate in the Student Union? It has an interesting set of locks.
There are funny rhymes, references to perspective, and odd mentions of eggs!
And if you think the stuff in your browser looks strange, you should see the page source...
Special tools? No, I don't think you'll need any extra tooling for those locks.
BUT - I'm pretty sure you'll need to use Chrome's developer tools for that one.
Or sorry, you're a Firefox fan?
Yeah, Safari's fine too - I just have an ineffible hunger for a physical Esc key.
Edge? That's cool. Hm? No no, I was thinking of an unrelated thing.
Curl fan? Right on! Just remember: the Windows one doesn't like double quotes.
Old school, huh? Oh sure - I've got what you need right here...
And I hear the Holiday Hack Trail game will give hints on the last screen if you complete it on Hard.`,
`[Shiny Upatree Chat] Psst - hey!
I'm Shinny Upatree, and I know what's going on!
Yeah, that's right - guarding the sleigh shop has made me privvy to some serious, high-level intel.
In fact, I know WHO is causing all the trouble.
Cindy? Oh no no, not that who. And stop guessing - you'll never figure it out.
The only way you could would be if you could break into my crate, here[https://crate.elfu.org/].
You see, I've written the villain's name down on a piece of paper and hidden it away securely!`];
  const assignment = 'Visit Shinny Upatree in the Student Union and help solve their problem. What is written on the paper you retrieve for Shinny? For hints on achieving this objective, please visit the Student Union and talk with Kent Tinseltooth.'
  const data = useStaticQuery(graphql`
    query {
      win11: file(relativePath: { eq: "win11.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      print: file(relativePath: { eq: "print.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock1: file(relativePath: { eq: "lock1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock2: file(relativePath: { eq: "lock2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock3: file(relativePath: { eq: "lock3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock4: file(relativePath: { eq: "lock4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock5: file(relativePath: { eq: "lock5.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock6: file(relativePath: { eq: "lock6.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock7: file(relativePath: { eq: "lock7.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock8: file(relativePath: { eq: "lock8.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock9: file(relativePath: { eq: "lock9.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lock10: file(relativePath: { eq: "lock10.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      crate: file(relativePath: { eq: "crate.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ludicrous: file(relativePath: { eq: "ludicrous.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text>The crate is at Student Union. When we click on the crate, it goes to <code>https://sleighworkshopdoor.elfu.org/</code>. I was using Chromium based Brave browser.</Text>
      <Text my={2}></Text>
      <Img fluid={data.crate.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <br />
      <Text pt={2} my={2}>First lock's code is already in Dev Tools console. <code>Command + Option + i</code> to open Dev Tools on Mac.</Text>
      <Img fluid={data.lock1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>For the second lock we need to look at print preview.</Text>
      <Img fluid={data.lock2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}><code>File -> Print</code></Text>
      <Img fluid={data.print.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>Third lock: just open Network Tab of Dev Tools and click on 'preview'</Text>
      <Img fluid={data.lock3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>#4: Application tab of Dev Tools, the click on Local Storage dropdown</Text>
      <Img fluid={data.lock4.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>Fifth code is found at Elements Tab of Dev Tools, clicking <code>head</code> to expand it</Text>
      <Img fluid={data.lock5.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>Number 6 will mess with CSS. We click on the hologram with Inspector tool (arrow), and change the value of 'perspective' in the Style tab on the bottom.</Text>
      <Img fluid={data.lock6.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>Code for lock 7 is found in Elements Tab, <code>head</code> -> look at <code>style</code> tag</Text>
      <Img fluid={data.lock7.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>For unlocking lock 8 we need to <code>Command + F</code> in the Elements Tab of Dev Tools. We look for 'eggs' and then click the <code>Event Listeners</code> tab on the bottom</Text>
      <Img fluid={data.lock8.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>Lock number 9 uses the Sources Tab of Dev Tools. <code>css -> styles.css</code> and <code>Command + F</code> to look for 'active'</Text>
      <Img fluid={data.lock9.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>To open the last lock we need to drag divs with class names <code>macaroni</code>,<code>swab</code>, and <code>gnome</code> inside lock10. And drag the <code>cover</code> div down.</Text>
      <Img fluid={data.lock10.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '90vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>All locks are open! The secret is revealed!</Text>
      <Img fluid={data.win11.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text pt={4} my={2}>or check out my <a href='https://github.com/Nukki/HolidayHackChallenge2019'>github</a> to see the JavaScript code to automate the solution. </Text>
      <Img fluid={data.ludicrous.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};






// hhc://trail.hhc/trail/?difficulty=0&distance=8000&money=9999&pace=0&curmonth=9&curday=1&reindeer=2&runners=2&ammo=100&meds=20&food=392&name0=Ron&health0=100&cond0=0&causeofdeath0=&deathday0=0&deathmonth0=0&name1=Jen&health1=100&cond1=0&causeofdeath1=&deathday1=0&deathmonth1=0&name2=Chris&health2=100&cond2=0&causeofdeath2=&deathday2=0&deathmonth2=0&name3=Jane&health3=100&cond3=0&causeofdeath3=&deathday3=0&deathmonth3=0
